import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/customers/get/by-id.ts
var by_id_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var MultisitePlanSchema = z.object({
	apiRequestsPerMinute: z.number(),
	name: z.string(),
	uuid: z.string()
});
var SubscriptionDetailsSchema = z.object({
	additionalStreamMinutes: z.number(),
	additionalViewerMinutes: z.number(),
	aiVideosPerMonth: z.number(),
	concurrentRtmpStreams: z.number(),
	contentLibraryTrialCancelled: z.boolean(),
	contentLibraryTrialEndTimestamp: z.string(),
	contentLibraryTrialPlanId: z.string(),
	contentLibraryTrialStatus: z.string(),
	subtitlesHoursPerMonth: z.number()
});
var UsageSummarySchema = z.object({
	concurrentWebBroadcasts: z.number(),
	enterpriseLicenses: z.number(),
	inUseEnterpriseLicenses: z.number(),
	inUseLanCloudSiteLicenses: z.number(),
	inUseNonProductionSiteLicenses: z.number(),
	inUseProfessionalLicenses: z.number(),
	inUseSoftwareEncoders: z.number(),
	lanCloudSiteLicenses: z.number(),
	nonProductionSiteLicenses: z.number(),
	professionalLicenses: z.number(),
	softwareEncoderLicenses: z.number(),
	subtitlesHoursPerMonth: z.number(),
	webBandwidth: z.number()
});
var VodPlanSchema = z.object({
	allowAnalytics: z.boolean(),
	allowPlaylists: z.boolean(),
	allowSchedule: z.boolean(),
	allowShare: z.boolean(),
	allowUpload: z.boolean(),
	allowVodex: z.boolean(),
	apiRequestsPerMinute: z.number(),
	deleteAfterDays: z.number().nullish(),
	hidden: z.boolean(),
	name: z.string(),
	storageCapGB: z.number(),
	uuid: z.string()
});
var WebPlanSchema = z.object({
	allowDownload: z.boolean(),
	allowPlayerConfig: z.boolean(),
	allowQrClickOverlays: z.boolean(),
	allowQrCodeDetection: z.boolean(),
	allowSimLive: z.boolean(),
	allowStreamUrls: z.boolean(),
	allowVideoUpload: z.boolean(),
	apiRequestsPerMinute: z.number(),
	dataUsageCapGb: z.number().nullable(),
	forceBranded: z.boolean(),
	maxIngestHeight: z.number(),
	name: z.string(),
	numberOfConcurrentWebEvents: z.number().nullable(),
	numberOfSocialMediaDestinations: z.number(),
	streamMinutes: z.number().nullable(),
	uuid: z.string(),
	viewerMinutes: z.number().nullable()
});
var ResponseSchema = z.object({
	active: z.boolean(),
	additionalAnnualWebDataGb: z.number().optional(),
	additionalConcurrentWebEvents: z.number(),
	additionalVodBandwidthGb: z.number(),
	additionalVodStorageGb: z.number(),
	additionalWebDataGb: z.number(),
	allowed16ChannelAudio: z.boolean(),
	annualWebDataGb: z.number().optional(),
	billingYearlyMultiSite: z.boolean().nullable(),
	billingYearlyVod: z.boolean().nullable(),
	billingYearlyWeb: z.boolean().nullable(),
	defaultWebEventProfileType: z.string().nullable(),
	masterEcg: z.string().nullable(),
	maxSites: z.number(),
	msa: z.boolean(),
	multisitePlan: MultisitePlanSchema.nullable(),
	multisitePlanId: z.string().nullable(),
	multisitePlanName: z.string().nullable(),
	multisiteStartDate: z.string().nullable(),
	name: z.string(),
	numConcurrentTranscodes: z.number(),
	regionId: z.string(),
	subscriptionDetails: SubscriptionDetailsSchema,
	usageSummary: UsageSummarySchema,
	uuid: z.string(),
	vodPlan: VodPlanSchema.nullable(),
	vodPlanId: z.string().nullable(),
	vodPlanName: z.string().nullable(),
	vodStartDate: z.string().nullable(),
	webBandwidth: z.number(),
	webMaxDeleteAfter: z.number().nullable(),
	webPlan: WebPlanSchema.nullable(),
	webPlanId: z.string().nullable(),
	webPlanName: z.string().nullable(),
	webStartDate: z.string().nullable()
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { by_id_exports };

//# sourceMappingURL=by-id.js.map